import type { ReactNode } from "react";
import { allDocPages } from "../content";
import DocsLayout from "../layout";
import { CoverageTable, Legend } from "./components";

const rows = [
  { market: "Canadian Mutual Funds", historical: "Y", delayed: "N/A", realTime: "N/A", level2: "N/A" },
  { market: "US Mutual Funds", historical: "Y", delayed: "N/A", realTime: "N/A", level2: "N/A" },
];

export default function FundsPage(): ReactNode {
  const page = allDocPages.find(p => p.slug === "data-coverage-funds")!;
  return (
    <DocsLayout page={page}>
      <Legend/>
      <CoverageTable rows={rows}/>
    </DocsLayout>
  );
}
